import React from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { useFetchHealthQuery } from "store/RTK/healthApi";
import { useFetchSettingsQuery as useFetchShopSettingsQuery } from "store/RTK/optionsApi";
import { useLocation } from "react-router-dom";

import styled from "styled-components";
import {
  List,
  ListItem,
  Link as MaterialLink,
  Typography,
} from "@mui/material";
import { DropdownSection } from "./Components";
import navbarConfig from "../../navbarConfig";

const CompanyDropdownEl = styled.div`
  width: 18.5rem;
`;

const CompanyDropdown = () => {
  const { t } = useTranslation();
  const isOnline = useSelector((state: RootState) => state.auth.isOnline);
  const { data: health, isError: isHealthError, isLoading } = useFetchHealthQuery();
  const backendHealthy = isLoading || (!isHealthError && health?.status === "ok");
  const { data: shopSettings } = useFetchShopSettingsQuery();
  const isUnderConstruction = Boolean((shopSettings as any)?.underConstruction);
  const location = useLocation();
  const isPreviewUC = location.pathname === "/__uc";

  const navConfig = navbarConfig(t, isOnline && backendHealthy && !isUnderConstruction && !isPreviewUC);
  const companyItem = navConfig.find((item) => item.title === t("aboutUs"));

  const scrollToSection = (sectionId: string) => {
    const sectionElement = document.getElementById(sectionId);
    const offset = 128;
    if (sectionElement) {
      const targetScroll = sectionElement.offsetTop - offset;
      sectionElement.scrollIntoView({ behavior: "smooth" });
      window.scrollTo({
        top: targetScroll,
        behavior: "smooth",
      });
    }
  };

  return (
    <CompanyDropdownEl>
      <DropdownSection data-first-dropdown-section>
        <List sx={{ py: 0, pb: "24px" }}>
          {companyItem?.about?.map((item) => (
            <ListItem sx={{ px: 0 }} key={item.title}>
              <MaterialLink
                sx={{ display: "flex" }}
                color="text.secondary"
                component={RouterLink}
                to={item.link}
                onClick={() => scrollToSection(item.sectionId)}
                data-testid={item.sectionId === "products" ? "nav-about" : undefined}
              >
                {item.title} &rsaquo;
              </MaterialLink>
            </ListItem>
          ))}
        </List>
      </DropdownSection>
      <DropdownSection>
        <Typography
          variant="h6"
          component="p"
          sx={{ display: "flex", alignItems: "center" }}
          color="text.secondary"
        >
          {t("getInTouch")}
        </Typography>
        <List sx={{ mb: "24px" }}>
          {companyItem?.getInTouch?.map((item) => (
            <ListItem sx={{ px: 0 }} key={item.title}>
              <MaterialLink
                color="text.secondary"
                component={RouterLink}
                to={item.link}
              >
                {item.title} &rsaquo;
              </MaterialLink>
            </ListItem>
          ))}
        </List>
      </DropdownSection>
    </CompanyDropdownEl>
  );
};

export default CompanyDropdown;
